import React, { FC } from 'react'

import { CheckboxWithTxt } from 'src/components/molecules'

type Props = {
  isSendAssignEmail: boolean
  checkboxPosition?: 'left' | 'right'
  updateCheck: (newValue: boolean) => void
  className?: string
}

export const AssignMailCheckbox: FC<Props> = ({
  isSendAssignEmail,
  checkboxPosition = 'left',
  updateCheck,
  className,
}) => {
  return (
    <div className={className}>
      <CheckboxWithTxt
        text="アサイン通知メールを送信"
        checked={isSendAssignEmail}
        checkboxPosition={checkboxPosition}
        onClick={() => updateCheck(!isSendAssignEmail)}
      />
    </div>
  )
}
